'use strict';

exports.__esModule = true;
exports.default = addSpace;
function addSpace() {
    return { type: 'space', value: ' ' };
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/postcss-ordered-values/dist/lib/addSpace.js
// module id = 1629
// module chunks = 0